var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "footer--mentions"
  }, [_c('p', [_vm._v("\n    ©\n    "), _vm.locale.market !== 'IT' ? _c('span', [_c('span', {
    staticClass: "d-none d-lg-inline-block"
  }, [_vm._v(" Maisons du Monde ")]), _vm._v("\n      " + _vm._s(_vm.getDate) + " -\n    ")]) : _c('span', [_c('span', {
    staticClass: "d-none d-sm-inline-block"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('footer.copyright_mdm')) + " -\n      ")])]), _vm._v(" "), _vm.isMarketplaceOpen ? _c('span', _vm._l(_vm.cguLinks, function (cgu, key) {
    return _c('MdmLink', {
      key: key,
      attrs: {
        "url": cgu.url,
        "is-scramble-link": _vm.isScrambleLink,
        "is-nuxt": true,
        "target": "_blank"
      },
      domProps: {
        "textContent": _vm._s(cgu.label)
      }
    });
  }), 1) : _vm._e(), _vm._v(" "), _c('MdmLink', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: 'footer.help_and_faqs',
      expression: "'footer.help_and_faqs'"
    }],
    attrs: {
      "url": _vm.helpAndFaqsLinks,
      "target": "_blank",
      "is-scramble-link": _vm.isScrambleLink
    }
  }), _vm._v("\n    -\n    "), _vm.termsAndConditionsPro ? _c('span', [_c('MdmLink', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: _vm.termsAndConditionsPro,
      expression: "termsAndConditionsPro"
    }],
    attrs: {
      "url": "/".concat(_vm.setLocale, "/e/legal/cgv-pro"),
      "is-scramble-link": _vm.isScrambleLink,
      "is-nuxt": true
    }
  }), _vm._v("\n      -")], 1) : _vm._e(), _vm._v(" "), _c('MdmLink', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: 'footer.terms_conditions',
      expression: "'footer.terms_conditions'"
    }],
    attrs: {
      "url": "/".concat(_vm.setLocale, "/e/legal/cgv"),
      "is-scramble-link": _vm.isScrambleLink,
      "is-nuxt": true
    }
  }), _vm._v("\n    -\n    "), _vm.isMarketOpen ? _c('MdmLink', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: 'footer.sitemap',
      expression: "'footer.sitemap'"
    }],
    attrs: {
      "url": "/".concat(_vm.setLocale, "/sitemap"),
      "is-scramble-link": _vm.isScrambleLink,
      "is-nuxt": true
    }
  }) : _vm._e(), _vm._v("\n    -\n    "), _c('MdmLink', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: 'footer.mentions',
      expression: "'footer.mentions'"
    }],
    attrs: {
      "url": _vm.legalNoticeLinks,
      "target": "_blank",
      "is-scramble-link": _vm.isScrambleLink,
      "is-nuxt": true
    }
  }), _vm._v("\n    -\n    "), _c('MdmLink', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: 'footer.privacy_policy',
      expression: "'footer.privacy_policy'"
    }],
    attrs: {
      "url": _vm.privacyPolicyLinks,
      "target": "_blank",
      "is-scramble-link": _vm.isScrambleLink,
      "is-nuxt": true
    }
  }), _vm._v("\n    -\n    "), _vm.locale.iso === 'fr-FR' ? _c('MdmLink', {
    attrs: {
      "url": "/".concat(_vm.setLocale, "/e/legal/politique-cookies"),
      "target": "_blank",
      "is-scramble-link": _vm.isScrambleLink,
      "is-nuxt": true
    },
    domProps: {
      "textContent": _vm._s("".concat(_vm.$t('footer.cookies_policy'), " -"))
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: 'footer.cookies_parameter',
      expression: "'footer.cookies_parameter'"
    }],
    staticClass: "cookies-parameter",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.editCookies();
      }
    }
  }), _vm._v("\n    -\n    "), _c('MdmLink', {
    directives: [{
      name: "t",
      rawName: "v-t",
      value: 'footer.customer_reviews',
      expression: "'footer.customer_reviews'"
    }],
    attrs: {
      "url": _vm.customerReviewsLinks,
      "target": "_blank",
      "is-scramble-link": _vm.isScrambleLink,
      "is-nuxt": true
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };